import { useFormContext, useWatch } from 'react-hook-form';
import { FormValues } from '@/containers/ConfigurePage/components/FormConfig/formData';
import { getSelectedSubscription } from '@/containers/ConfigurePage/utils/getSelectedSubscription';
import { TransformedAssetCategoryResult } from '@/types/TransformedAssetCategoryResults';
import type { ProductSubscriptionByRegionResponse } from '@/utils/fetch/fetchProductSubscriptionByRegion';

export const useStudentDiscount = (
  product: TransformedAssetCategoryResult,
  subscriptions: ProductSubscriptionByRegionResponse
) => {
  const { control } = useFormContext<FormValues>();
  const currentFormValues = useWatch<FormValues>({ control });

  const currentSubscription = getSelectedSubscription({
    currentFormValues,
    product,
    subscriptions,
  });
  const studentSubscription = subscriptions.find(
    sub =>
      sub.customerType === 'student' &&
      sub.isFlexible === currentSubscription?.isFlexible &&
      sub.isSpecialOffer === currentSubscription.isSpecialOffer &&
      sub.minDurationMonths === currentSubscription.minDurationMonths
  );
  const normalSubscription = subscriptions.find(
    sub =>
      sub.customerType === 'normal' &&
      sub.isFlexible === currentSubscription?.isFlexible &&
      sub.isSpecialOffer === currentSubscription.isSpecialOffer &&
      sub.minDurationMonths === currentSubscription.minDurationMonths
  );

  if (
    !studentSubscription ||
    // This applies to Deluxe 7 in the Netherlands,
    // where there is no price difference between yes and no,
    // but we still need to know if the customer is a student or not
    studentSubscription.rate === normalSubscription?.rate
  ) {
    return undefined;
  }

  return normalSubscription
    ? {
        normalRate: normalSubscription.rate,
        studentRate: studentSubscription.rate,
      }
    : undefined;
};
